module.exports = __webpack_public_path__ + "static/showreel_2025-35b69e32cc8a07bb8eafa946fe4de3ae.mp4";